import { createSignal } from 'solid-js'
import { formStore } from '/web/store/form'
import { toastStore } from '/web/store'
import AccountSidebar from '/web/pages/AiFans/AccountSidebar'
import HeaderContainer from '/web/shared/aifans/HeaderContainer'
import Footer from '/web/shared/aifans/Footer'
import { A } from '@solidjs/router'
import { Title, Meta, Link } from '@solidjs/meta'
import { getCanonicalUrl } from '/web/shared/aifans/lib/config-util'

export default function ContactUs() {
  const [name, setName] = createSignal('')
  const [email, setEmail] = createSignal('')
  const [issue, setIssue] = createSignal('')
  const [message, setMessage] = createSignal('')
  const [valid, setValid] = createSignal(true)
  const [checkEmail, setCheckEmail] = createSignal(false)
  const [loading, setLoading] = createSignal(false)

  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  const handleSubmit = async (e: Event) => {
    e.preventDefault()

    const validEmail = re.test(email())

    if (!name() || !validEmail) {
      setValid(false)
      return
    }

    setLoading(true)
    const success = await formStore.submitContactForm({
      name: name(),
      email: email(),
      issue: issue(),
      message: message(),
    })
    setLoading(false)

    if (success) {
      // Clear form
      setName('')
      setEmail('')
      setIssue('')
      setMessage('')
      setValid(true)
      setCheckEmail(false)
    }
  }

  const handleEmailChange = (e: any) => {
    setEmail(e.target.value)

    const validEmail = re.test(email())
    console.log(validEmail)
    setCheckEmail(validEmail)
  }

  return (
    <>
      <Title>CosplayFans - Contact | Reach Our Support & Services Team</Title>
      <Meta name="og:title" content="CosplayFans - Contact | Reach Our Support & Services Team" />
      <Meta
        name="description"
        content="Get in touch with the CosplayFans.ai team for support, questions, or inquiries. We're here to help with fan pages, live chat, ai generated images & more."
      />
      <Meta
        name="og:description"
        content="Get in touch with the CosplayFans.ai team for support, questions, or inquiries. We're here to help with fan pages, live chat, ai generated images & more."
      />
      <Link rel="canonical" href={getCanonicalUrl('/contact-us/')} />
      <HeaderContainer />
      <main class="contact-us page-bg relative overflow-hidden bg-main  pt-20 font-normal sm:pt-28 md:bg-none">
        <div class="container relative z-20">
          <div class="wrapper gap-8 lg:flex">
            <AccountSidebar />

            {/* right */}
            <div class="right flex w-full flex-col">
              {/* head */}
              <div class="head gray-to-tran mb-3 rounded-xl text-2xl font-semibold sm:mb-7 sm:p-4 sm:text-[28px]">
                <h2>Contact Us!</h2>
              </div>

              <div class="content gray-to-tran w-full rounded-xl sm:p-6">
                <div class="title">
                  <h4 class="text-xl font-semibold sm:text-[22px]">Feedback & Suggestion</h4>
                  <p class="text-sm sm:text-base">
                    At CosplayFans, we bring your wildest fantasies to life. Need to share feedback
                    or report a bug? Fill out the form, and you can expect a response within 24
                    hours.
                  </p>
                </div>

                {/* contact form */}
                <form class="contact-form mt-8 grid gap-4">
                  <div class="grid gap-4 sm:grid-cols-2">
                    {/* name() */}
                    <div class="name() space-y-1.5">
                      <label for="name()">
                        Name <span class={`text-sm text-cosplay-red`}>(Required)</span>
                      </label>
                      <input
                        onChange={(e) => setName(e.target.value)}
                        value={name()}
                        id="name()"
                        type="text"
                        class="w-full rounded-md border border-transparent bg-white/10 px-4 py-2 outline-none transition-all duration-300 focus:border-cosplay-red"
                        placeholder="Enter Name"
                      />
                    </div>
                    {/* email() */}
                    <div class="email() space-y-1.5">
                      <label for="email()">
                        Email{' '}
                        <span
                          class={`${
                            !checkEmail() && !valid() && email() ? '' : 'hidden'
                          } text-sm text-cosplay-red`}
                        >
                          (Invalid Email)
                        </span>
                        <span class={`text-sm text-cosplay-red`}>(Required)</span>
                      </label>
                      <input
                        onChange={(e) => {
                          handleEmailChange(e)
                        }}
                        value={email()}
                        id="email()"
                        type="email()"
                        class="w-full rounded-md border border-transparent bg-white/10 px-4 py-2 outline-none transition-all duration-300 focus:border-cosplay-red"
                        placeholder="Enter Email"
                      />
                    </div>
                  </div>

                  {/* issue() */}
                  <div class="issue() space-y-1.5">
                    <label for="issue()">What’s The Issue</label>
                    <input
                      onChange={(e) => setIssue(e.target.value)}
                      value={issue()}
                      id="issue()"
                      type="text"
                      class="focus:border-red w-full rounded-md border border-transparent bg-white/10 px-4 py-2 outline-none transition-all duration-300"
                      placeholder="Write Issue"
                    />
                  </div>

                  {/* message() */}
                  <div class="message() space-y-1.5">
                    <label for="message()">What Can Do We For You?</label>
                    <textarea
                      onChange={(e) => setMessage(e.target.value)}
                      value={message()}
                      id="message()"
                      rows={5}
                      class="focus:border-red w-full rounded-md border border-transparent bg-white/10 px-4 py-2 outline-none transition-all duration-300"
                      placeholder="Write"
                    ></textarea>
                  </div>

                  <button
                    onClick={handleSubmit}
                    disabled={loading()}
                    class="w-full max-w-[10rem] rounded-lg bg-primary px-6 py-2 disabled:opacity-50"
                  >
                    {loading() ? 'Sending...' : 'Send'}
                  </button>
                </form>

                {/* info */}
                <div class="info mt-10 space-y-4">
                  <div class="text">
                    <h3 class="text-lg font-semibold sm:text-[22px]">Media & Press Enquiries</h3>
                    <p>
                      To chat with us about media opportunities and partnerships, you can contact us
                      at <a href="mailto:support@cosplayfans.ai">support@cosplayfans.ai</a>
                    </p>
                  </div>

                  <div class="text">
                    <h3 class="text-lg font-semibold sm:text-[22px]">
                      Copyright And DCMA Enquiries
                    </h3>
                    <p>
                      If you have a copyright issue(s) to raise or need to inform us of a DMCA
                      request, please email{' '}
                      <a href="mailto:support@cosplayfans.ai">support@cosplayfans.ai</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* faq section */}
      <section class="contact-us-faq bg-main pb-20 pt-20 md:pb-36">
        <div class="container">
          <div class="content rounded-lg p-6 text-center">
            <div class="wrap mx-auto w-full max-w-[40rem] space-y-5">
              <h3 class="text-xl font-semibold sm:text-2xl md:text-[28px]">
                Check Out Our <A href="/faq">Frequently Asked Questions</A> For A Quicker Solution
                To Your Problem
              </h3>
              <p>
                It’s filled with detailed answers to common issues, step-by-step guides, and helpful
                tips to resolve most concerns without needing further assistance.
              </p>
              <button class="mt-2 w-full max-w-[8rem] rounded-xl px-4 py-2.5">
                <A href="/faq">FAQ’s</A>
              </button>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}
